<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card>
          <div class="row align--center">
            <div class="flex xs6 md3">
              <va-input
                :value="nomRe"
                :placeholder="$t('poissonnierTable.searchByName')"
                removable
                @input="searchNom"
              >
                <va-icon name="fa fa-search" slot="prepend" />
              </va-input>
            </div>

            <div class="flex xs6 md3">
              <va-input
                :value="cpRe"
                :placeholder="$t('poissonnierTable.searchByPostcode')"
                removable
                @input="searchPostcode"
              >
                <va-icon name="fa fa-search" slot="prepend" />
              </va-input>
            </div>
            <div class="flex xs12 md4">
              <div class="row row-inside">
                <va-button-toggle
                  outline
                  class="toggle-activite"
                  v-model="showinactive"
                  :options="options"
                />
                <h5
                  class="selection-nb-title"
                  :style="{ color: this.$themes.primary }"
                >
                  Sélect. : {{ filteredData.length }}
                </h5>
                <va-popover message="Rafraichir" placement="top">
                  <va-button
                    class="selection-refresh"
                    flat
                    color="primary"
                    icon="fa fa-refresh"
                    @click="loadList()"
                  />
                </va-popover>
              </div>
            </div>
            <div class="flex md1">
              <va-select
                label="Code APE"
                v-model="selectApe"
                textBy="description"
                :options="apeOptions"
                no-clear
              />
            </div>

            <div class="flex xs6 md1">
              <va-input
                class="centered"
                :value="perPage"
                :label="$t('tables.perPage')"
                @input="changePageNumber"
              ></va-input>
            </div>
          </div>
          <div v-if="loadingStatuts" class="d-flex justify--center spinner">
            <div>
              <va-progress-circle indeterminate />
            </div>
          </div>

          <va-data-table
            ref="dataTableSyndicat"
            class="va-table--hoverable va-table--stripped no-overflow"
            :fields="fields"
            :data="filteredData"
            :no-data-label="$t('poissonnierTable.empty')"
            :per-page="parseInt(perPage)"
            @row-clicked="showEntreprise"
            clickable
            page="3"
          >
            <template slot="adhesion" slot-scope="props">
              <div class="align-center">
                <va-badge
                  v-show="props.rowData.id_link"
                  class="fullwidth"
                  color="gray"
                  >Entreprise liée</va-badge
                >
                <va-badge
                  v-show="props.rowData.unpf_adhesion"
                  class="fullwidth"
                  color="success"
                  >UNPF</va-badge
                >
                <va-badge
                  v-show="
                    !props.rowData.unpf_adhesion &&
                      props.rowData.unpf_adhesion_ind
                  "
                  class="fullwidth"
                  color="success"
                  >UNPF (indirecte)</va-badge
                >
                <va-badge
                  v-show="props.rowData.spef_adhesion"
                  class="fullwidth"
                  color="success"
                  >SPEF</va-badge
                >
                <va-badge
                  v-show="
                    !props.rowData.spef_adhesion &&
                      props.rowData.spef_adhesion_ind
                  "
                  class="fullwidth"
                  color="success"
                  >SPEF (indirecte)</va-badge
                >
                <va-badge
                  v-if="props.rowData.adhesions_agromer"
                  class="fullwidth"
                  color="warning"
                  >AGROMER</va-badge
                >
                <va-badge
                  v-if="props.rowData.adhesions_opam"
                  class="fullwidth"
                  color="info"
                  >OPAM</va-badge
                >
                <va-badge
                  v-show="props.rowData.adhesions_scapp"
                  class="fullwidth"
                  color="danger"
                  >SCAPP</va-badge
                >
                <va-badge
                  v-show="props.rowData.adhesions_languedoc"
                  class="fullwidth"
                  color="dark"
                  >LANGUEDOC ROUSSILLON</va-badge
                >
                <va-badge
                  v-show="props.rowData.adhesions_vendee"
                  class="fullwidth"
                  color="dark"
                  >VENDEE</va-badge
                >
                <va-badge
                  v-show="props.rowData.adhesions_sdep"
                  class="fullwidth"
                  color="dark"
                  >S.D.E.P.</va-badge
                >
              </div>
            </template>

            <template slot="verification" slot-scope="props">
              <div class="align-center">
                <va-icon
                  name="fa fa-circle"
                  :color="props.rowData.verifColor"
                  size="1.5rem"
                />
              </div>
            </template>
            <template slot="adresseFull" slot-scope="props">
              <div class="align-center small-text">
                {{ props.rowData.adresse_full }}
              </div>
            </template>

            <template slot="contact_name" slot-scope="props">
              <div class="align-center small-text">
                {{ props.rowData.contact_name }}
              </div>
            </template>

            <template slot="relance" slot-scope="props">
              <div class="row row-inside align-center">
                <div class="flex md12">
                  <va-badge
                    v-if="props.rowData.maxniveau === 1"
                    color="success"
                    class="fullwidth"
                    >Niveau 1</va-badge
                  >
                  <va-badge
                    v-if="props.rowData.maxniveau === 2"
                    color="warning"
                    class="fullwidth"
                    >Niveau 2</va-badge
                  >
                  <va-badge
                    v-if="props.rowData.maxniveau === 3"
                    color="danger"
                    class="fullwidth"
                    >Niveau 3</va-badge
                  >
                  <p class="last-send" v-if="props.rowData.latestenvoi">
                    {{ props.rowData.latestenvoi }}
                  </p>
                </div>
              </div>
            </template>

            <template slot="actions" slot-scope="props">
              <div class="row row-inside">
                <div class="flex md6">
                  <va-popover message="Envoyer un courriel" placement="top">
                    <va-button
                      flat
                      small
                      color="primary"
                      icon="fa fa-at"
                      :disabled="!props.rowData.email"
                      @click="openCourriel(props.rowData.email)"
                    />
                  </va-popover>
                  <va-popover message="Envoyer un courrier" placement="top">
                    <va-button
                      disabled
                      flat
                      small
                      color="primary"
                      icon="fa fa-envelope"
                    />
                  </va-popover>
                  <va-popover
                    v-if="isAdmin"
                    message="Envoyer un SMS"
                    placement="top"
                  >
                    <va-button
                      disabled
                      flat
                      small
                      color="primary"
                      icon="fa fa-mobile-phone"
                    />
                  </va-popover>
                </div>
                <div
                  class="flex md6"
                  v-if="
                    props.rowData.adhesion_statuts === 2 && syndicat !== 'opef'
                  "
                >
                  <va-button
                    class="fullwidth"
                    small
                    :color="props.rowData.colorBulletin"
                    @click="openBA(props.rowData)"
                    >Bulletin adhésion</va-button
                  >
                  <va-button
                    class="fullwidth"
                    outline
                    small
                    :color="props.rowData.colorRecu"
                    @click="openRecu(props.rowData)"
                    >Reçu adhésion</va-button
                  >
                </div>
              </div>
            </template>
          </va-data-table>
        </va-card>
      </div>
    </div>
    <dashboard-fiche-entreprise
      v-model="showFicheEntreprise"
      :tableentreprise="tableentreprise"
      @update="updateEntreprise"
      @create="addEntreprise"
    />
    <bulletins-adhesions-manager
      v-model="showBulletin"
      :idadhesion="idadhesion"
      :entrepriseName="entrepriseName"
      v-on:uploaded="changeColor('success', 'bulletin')"
      v-on:deleted="changeColor('info', 'bulletin')"
    />
    <recu-manager
      title="Reçu d'adhésion"
      :idadhesion="idadhesion"
      v-model="showRecu"
      v-on:ok="changeColor('success', 'recu')"
    ></recu-manager>
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, debounce, findIndex, deburr } from "lodash";
import DashboardFicheEntreprise from "../DashboardFicheEntreprise";
import BulletinsAdhesionsManager from "../components/BulletinsAdhesionsManager";
import RecuManager from "../components/RecuManager";
import { mapGetters } from "vuex";

export default {
  components: {
    DashboardFicheEntreprise,
    BulletinsAdhesionsManager,
    RecuManager
  },
  props: ["syndicat"],
  data() {
    return {
      selectApe: { id: 99, description: "Tous" },
      apeOptions: [
        { id: 0, description: "4723Z" },
        { id: 1, description: "4781Z" },
        { id: 2, description: "4638A" },
        { id: 3, description: "Autre / NR" },
        { id: 4, description: "8559A" },
        { id: 99, description: "Tous" }
      ],
      loadingStatuts: true,
      dateCompare: new Date(),
      entrepriseToDelete: null,
      deleteModalMessage: "Supprimer l'entreprise?",
      showConfirmDelete: false,
      // TODO precise the sending of sms behavior
      isAdmin:
        this.$store.getters.user.droits &&
        this.$store.getters.user.droits === "ADMIN",
      options: [
        { label: "Adh.", value: "adherent" },
        { label: "Récents", value: "1yo" },
        { label: "Exp.", value: "expired" },
        { label: "Tous", value: "all" }
      ],
      showinactive: "adherent",
      tableentreprise: "",
      modalWidth: "100%",
      show: true,
      showFicheEntreprise: false,
      isaction: false,
      nomRe: null,
      cpRe: null,
      dataEntreprises: [],
      perPage: "6",
      showBulletin: false,
      showRecu: false,
      idadhesion: null,
      identreprise: null,
      entrepriseName: null
    };
  },
  computed: {
    ...mapGetters(["loadEntreprise"]),
    fields() {
      return [
        {
          name: "nom",
          title: this.$t("poissonnierTable.headings.enseigne"),
          sortField: "nom",
          width: "15%"
        },

        {
          name: "__slot:adresseFull",
          title: "Adresse",
          sortField: "adresse_full",
          width: "10%",
          dataClass: "adresse-smalltext"
        },
        {
          name: "__slot:contact_name",
          title: "Dirigeant",
          sortField: "contact_name",
          width: "8%",
          dataClass: "adresse-smalltext"
        },
        {
          name: "first_adhesion",
          title: "Première adhésion",
          sortField: "first_adhesion",
          width: "9%"
        },
        {
          name: "fin_adhesion",
          title: "Fin d'adhésion",
          sortField: "fin_adhesion",
          width: "9%"
        },
        {
          name: "__slot:verification",
          title: "Vérification",
          sortField: "dateVerification",
          width: "5%"
        },
        {
          name: "__slot:adhesion",
          title: this.$t("poissonnierTable.headings.adhesion"),
          sortField: "nadhesion",
          width: "10%"
        },
        {
          name: "__slot:relance",
          title: "Dernière relance",
          sortField: "latestEnvoi",
          width: "10%"
        },

        {
          name: "__slot:actions",
          dataClass: "text-right",
          width: "24%"
        }
      ];
    },
    filteredData() {
      let filteredData = this.dataEntreprises;

      if (
        (!this.nomRe || this.nomRe.length < 1) &&
        (!this.cpRe || this.cpRe.length < 1) &&
        this.showinactive === "all" &&
        this.selectApe.id === 99
      ) {
        return filteredData;
      }
      // add linked firm when filtering
      let linkList = [];
      let entId = [];

      filteredData = filteredData.filter(item => {
        let boolcond = true;

        if (item.closure_date || item.liquidation) {
          boolcond = false;
        }

        // also show indirect adhesions
        if (
          this.showinactive === "adherent" &&
          item.adhesion_statuts !== 2 &&
          item.adhesion_statuts !== 3
        ) {
          boolcond = false;
        }

        if (this.showinactive === "1yo" && item.adhesion_statuts !== 1) {
          if (item.identreprise == "58b55e81-be52-49e8-a8c3-14a2c230570a")
            console.log(item);
          boolcond = false;
        }

        if (this.showinactive === "expired" && item.adhesion_statuts !== 0) {
          boolcond = false;
        }

        if (this.selectApe.id === 0 && item.code_ape !== 0) {
          boolcond = false;
        }
        if (this.selectApe.id === 1 && item.code_ape !== 1) {
          boolcond = false;
        }
        if (this.selectApe.id === 2 && item.code_ape !== 2) {
          boolcond = false;
        }
        if (
          this.selectApe.id === 3 &&
          (item.code_ape === 0 || item.code_ape === 1 || item.code_ape === 2)
        ) {
          boolcond = false;
        }

        if (this.nomRe && this.nomRe.length >= 1) {
          let nomCpre = deburr(this.nomRe).toLowerCase();
          boolcond =
            boolcond &&
            (deburr(item.nom)
              .toLowerCase()
              .includes(nomCpre) ||
              deburr(item.contact_name)
                .toLowerCase()
                .includes(nomCpre));
        }

        if (this.cpRe && this.cpRe.length >= 1) {
          let cpCpre = deburr(this.cpRe).toLowerCase();
          boolcond =
            boolcond &&
            deburr(item.adresse_full)
              .toLowerCase()
              .includes(cpCpre);
        }

        if (boolcond) {
          entId.push(item.identreprise);
          if (item.id_link) {
            linkList.push(item.id_link);
          }
        }

        return boolcond || !!item.id_link;
      });

      // second filter to add the linked items

      filteredData = filteredData.filter(item => {
        if (
          entId.includes(item.identreprise) ||
          linkList.includes(item.id_link)
        ) {
          return true;
        } else {
          return false;
        }
      });
      return filteredData;
    }
  },
  mounted() {
    let pastYear = this.dateCompare.getFullYear() - 1;
    this.dateCompare.setFullYear(pastYear);
    this.loadList();
  },
  methods: {
    changeColor(color, document) {
      let index = findIndex(this.dataEntreprises, {
        identreprise: this.identreprise
      });

      if (document === "bulletin") {
        this.dataEntreprises[index].colorBulletin = color;
      } else {
        this.dataEntreprises[index].colorRecu = color;
      }
    },
    loadList() {
      this.loadingStatuts = true;

      console.time("modifylistSyndicat");
      axios
        .get("/api/entreprises-list-syndicat", {
          params: { syndicat: this.syndicat }
        })
        .then(resp => {
          for (let value of resp.data) {
            value = this.transformEntrepriseDatas(value);
          }
          console.timeEnd("modifylistSyndicat");
          this.dataEntreprises = resp.data;
          this.loadingStatuts = false;
          this.showinactive = "adherent";
          this.selectApe = { id: 99, description: "Tous" };
        });
    },
    openCourriel(email) {
      this.isaction = true;
      window.location.href = "mailto:" + email;
    },
    openRecu(firmInfos) {
      this.isaction = true;
      this.idadhesion = firmInfos.idLateestAdhesion;
      this.identreprise = firmInfos.identreprise;
      this.showRecu = true;
    },
    async openBA(firmInfos) {
      this.isaction = true;
      this.idadhesion = firmInfos.idLateestAdhesion;
      this.identreprise = firmInfos.identreprise;
      this.entrepriseName = firmInfos.nom;
      this.showBulletin = true;
    },
    deleteFirm(entreprise, action) {
      this.isaction = true;
      //prepare and show modal
      if (action === 2) {
        this.deleteModalMessage =
          "Voulez vous supprimer : " +
          entreprise.nom +
          " et toutes les données associées?";
        this.entrepriseToDelete = cloneDeep(entreprise);
        this.showConfirmDelete = true;
      } else if (action === 0) {
        //annulation de la suppression
        this.entrepriseToDelete = null;
        this.showConfirmDelete = false;
      } else if (action === 1) {
        axios
          .delete("/api/entreprise", {
            data: { entreprise: this.entrepriseToDelete }
          })
          .then(res => {
            this.deleteEntrepriseFromTable(
              this.entrepriseToDelete.identreprise
            );
            this.launchEpicmaxToast("Entreprise supprimée");
          })
          .catch(err => {
            console.log(err);
            this.launchEpicmaxToast("Erreur lors de la suppression");
          });
      }
    },
    showEntreprise(entreprise) {
      if (!this.isaction) {
        this.showFicheEntreprise = true;
        this.tableentreprise = entreprise;
      }
      this.isaction = false;
    },
    searchNom: debounce(function(nomRe) {
      this.nomRe = nomRe;
    }, 400),
    changePageNumber: debounce(function(perPage) {
      var n = Math.floor(Number(perPage));
      if (n !== Infinity && String(n) === perPage && n >= 0) {
        this.perPage = perPage;
      } else {
        this.perPage = "6";
      }
    }, 400),
    searchPostcode: debounce(function(cpRe) {
      this.cpRe = cpRe;
    }, 400),
    switchPage: debounce(function(page) {
      this.$refs.dataTableSyndicat.currentPage = page;
      this.$refs.dataTableSyndicat.inputPage(page.toString());
    }, 400),
    deleteEntrepriseFromTable(idEntreprise) {
      let i = findIndex(this.dataEntreprises, ["identreprise", idEntreprise]);
      //force detection update of the dataarray
      this.$delete(this.dataEntreprises, i);
    },
    async getDataEntreprise(identreprise) {
      try {
        let entreprise = await axios.get("/api/entreprises-syndicat", {
          params: { identreprise: identreprise, syndicat: this.syndicat }
        });
        return entreprise.data;
      } catch (error) {
        console.log(error);
      }
    },
    async updateEntreprise(identreprise) {
      let page = this.$refs.dataTableSyndicat.currentPage;
      let index = findIndex(this.dataEntreprises, [
        "identreprise",
        identreprise
      ]);

      let value = await this.getDataEntreprise(identreprise);

      if (value) {
        value = this.transformEntrepriseDatas(value);
        //force update on deep change
        ///need to clean the data received
        this.$set(this.dataEntreprises, index, value);
      } else {
        //delete the firm
        this.dataEntreprises.splice(index, 1);
      }
      this.switchPage(page);
    },
    async addEntreprise(value) {
      value = await this.getDataEntreprise(value.identreprise);
      value = this.transformEntrepriseDatas(value);

      this.dataEntreprises.push(value);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    },

    transformEntrepriseDatas(value) {
      if (
        value.spef_adhesion ||
        value.unpf_adhesion ||
        value.adhesions_opam ||
        value.adhesions_agromer ||
        value.adhesions_scapp
      ) {
        value.nadhesion = "a";
      } else {
        value.nadhesion = "b";
      }

      value.contact_name = value.contact_name ? value.contact_name : "";

      if (value.latest_verification) {
        let t = value.latest_verification.split("-");
        let dateVerification = new Date(t[0], t[1] - 1, t[2]);
        value.dateVerification = value.latest_verification;
        value.verifMsg =
          t[2] + "-" + t[1] + "-" + t[0] + "  " + value.usernameverif;

        if (dateVerification > this.dateCompare) {
          // entreprise vérifiée dans l'année
          value.verifTxt = "Vérifié";
          value.verifColor = "success";
        } else {
          value.verifTxt = "A vérifier";
          value.verifColor = "warning";
        }
      } else {
        value.verifTxt = "Jamais vérifié";
        value.verifColor = "danger";
        value.dateVerification = "";
      }

      value.colorBulletin = value.bulletin ? "success" : "info";
      value.colorRecu = value.nbRecu > 0 ? "success" : "info";
      return value;
    }
  },
  watch: {
    loadEntreprise(newid) {
      if (newid) {
        let i = findIndex(this.dataEntreprises, ["identreprise", newid]);
        this.showEntreprise(this.dataEntreprises[i]);
        this.$store.commit("setLoadEntreprise", false);
      }
    }
  }
};
</script>

<style lang="scss">
.centered input {
  text-align: center;
}
.create-button {
  position: relative;
}
.toggle-activite {
  position: relative;
  top: -0.5em;
}
.align-center {
  text-align: center;
}
.spinner {
  top: 50%;
  left: 50%;
}
.adresse-smalltext {
  font-size: 0.9em;
}
.selection-nb-title {
  position: relative;
  top: 0.4em;
}
.no-overflow {
  overflow: hidden;
}
.selection-refresh {
  position: relative;
  top: -0.3em;
}

.small-text {
  font-size: 0.8em;
}
</style>
